var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-date-picker',{staticClass:"date-picker-salary",staticStyle:{"width":"100%"},attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"clearable":_vm.clearable,"format":_vm.format},model:{value:(_vm.pickerValComputed),callback:function ($$v) {_vm.pickerValComputed=$$v},expression:"pickerValComputed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }